export default {"src":"/_next/static/media/IMGN.26765df8.svg","height":18,"width":18};